<template>
  <div class="container">
    <Search />
    <InputForm />
  </div>
</template>

<script>
import InputForm from '../components/InputForm';
import Search from '../components/Search';

export default {
    name: 'Home',
    components: {
      InputForm,
      Search
    }
}
</script>
